// Lib
import { Dealer } from 'features/Dealers/DealerSelect/state/types';
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';
import { DealerInfo } from './types';


export interface ActionGetDealerInfoAPI extends Action {
    listingId: string
}


export const getDealerInfoAPI = (listingId: string): ActionGetDealerInfoAPI => ({
    type: ACTIONS.GET_DEALERINFO_API_REQUEST,
    listingId
});
;


export interface ActionGetDealerInfoAPISuccess extends Action {
    dealerinfo: DealerInfo
}

export const getDealerInfoAPISuccess = (dealerinfo: DealerInfo): ActionGetDealerInfoAPISuccess => ({
    type: ACTIONS.GET_DEALERINFO_API_SUCCESS,
    dealerinfo
});

export const getDealerInfoAPIError = (error: any): Action & { error: any } => ({
    type: ACTIONS.GET_DEALERINFO_API_ERROR,
    error
});




